import { TranslationsContext } from '@teliaee/telia-translate';
import React, { useContext } from 'react';
import { Anchor, Button, Container, Grid, GridColumn, Image, List, ListItem, Section, Text, Separator } from 'telia-front-react';
import config from '../../config';
import GaHelper from '../../util/GaHelper';
import { useStores } from '../../stores/RootStore';
import { languageSlug } from '../../stores/LanguageStore';
import { observer } from 'mobx-react';

const pushGaData = (eventLabel: string) => {
  GaHelper.pushGaData({
    eventCategory: '404 - Page Not Found',
    eventAction: 'Additional information',
    eventLabel: eventLabel
  });
};

const NotFound = (): JSX.Element => {
  const { translate } = useContext(TranslationsContext);
  const { app, languageStore } = useStores();

  const getSelfServiceUrl = (): string => {
    return config.diil.selfServiceUrl + languageSlug(languageStore.currentLanguage);
  };

  if (app === 'super') {
    return (
      <Section
        isFull
        pullTop="no-breadcrumbs"
        pullBottom="footer"
        minHeight={693}
        smallScreenImagePosition="above"
        backgroundImage={{
          role: 'presentation',
          sources: [
            {
              srcset:
                'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_2560/super/404/bg-error.png 2560w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_5120/super/404/bg-error.png 5120w',
              minWidth: '1920px'
            },
            {
              srcset:
                'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1920/super/404/bg-error.png 1920w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_3840/super/404/bg-error.png 3840w',
              minWidth: '1441px'
            },
            {
              srcset:
                'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1440/super/404/bg-error.png 1440w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1880/super/404/bg-error.png 2880w',
              minWidth: '1201px'
            },
            {
              srcset:
                'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1240/super/404/bg-error.png 1240w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_2480/super/404/bg-error.png 2480w',
              minWidth: '800px'
            }
          ],
          srcset:
            '//res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1200/super/404/hero-error-mob.png 1200w, //res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1600/super/404/hero-error-mob.png 1600w'
        }}
      >
        <Container>
          <Grid>
            <GridColumn width={['md-6']}>
              <Text>
                <h1 className="c-brand-primary-text">{translate('error.404.text')}</h1>
                <p className="h4">{translate('error.404.help')}</p>
                <Separator spacing="xxsmall" color="invisible" />
                <Button
                  text={translate('error.404.return')}
                  type="expressive"
                  iconRight="#arrow-right"
                  url="/"
                  onClick={() => pushGaData('Link - Superi avaleht')}
                />
              </Text>
            </GridColumn>
          </Grid>
        </Container>
      </Section>
    );
  }

  return (
    <Container>
      <Grid align={['center-xs', 'middle-xs']}>
        <GridColumn width={['xs']}>
          <Image
            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            srcset="//res.cloudinary.com/telia/image/upload/c_scale,w_462,fl_lossy,f_auto,q_auto:best/diil/veeb/404/diil-raamatuga-valge2.gif 462w, //res.cloudinary.com/telia/image/upload/c_scale,w_925,fl_lossy,f_auto,q_auto:best/diil/veeb/404/diil-raamatuga-valge2.gif 925w"
            className="lazyload img-responsive center-block"
            alt={translate('notFound.404.img.alt')}
            width={462}
          />
        </GridColumn>
        <GridColumn width={['xs']}>
          <div className="text">
            <h3 className="text__margin-double">{translate('error.404.text')}</h3>
            <p className="text__margin-double">{translate('error.404.help')}</p>
            <List>
              <ListItem>
                <Anchor url={getSelfServiceUrl()} onClick={() => pushGaData('Link - Self-Service')}>
                  {translate('error.404.selfservice')}
                </Anchor>
              </ListItem>
              <ListItem>
                <Anchor url="https://www.facebook.com/MobiilioperaatorDiil" onClick={() => pushGaData('Link - www.facebook.com/MobiilioperaatorDiil')}>
                  {translate('error.404.fb')}
                </Anchor>
              </ListItem>
              <ListItem>
                {translate('error.404.callmail')}{' '}
                <Anchor url="mailto:info@diil.ee" onClick={() => pushGaData('Link - info@diil.ee')}>
                  info@diil.ee
                </Anchor>
              </ListItem>
            </List>
            <p className="text__margin-double">
              <Button text={translate('error.404.return')} url="/" onClick={() => pushGaData('Link - Diil esileht')} />
            </p>
          </div>
        </GridColumn>
      </Grid>
    </Container>
  );
};

export default observer(NotFound);
